// Copyright (c) Docugami, Inc. All rights reserved.

import { MessageBusSingleton, TypedHandlerCallback } from "messaging/MessageBus";
import { IMessage, MessageId } from "messaging/MessageTypes"
import { useEffect, useRef, useState } from "react"

/**
 * Used to handle messages from the global MessageBus.  There can be any number of message handlers for a given type.
 * However, if you are not registered at the time that the message is fired, it will be lost.
 */
export const useMessageHandler = <T extends IMessage>(id: MessageId, callback: TypedHandlerCallback<T>) => {
    const [messageId] = useState(id);
    const handlerCallback = useRef(callback);

    useEffect(() => {
        handlerCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function onMessage(message: T) {
            handlerCallback.current(message);
        }

        const unregister = MessageBusSingleton.registerMessageHandler(messageId, onMessage);
        return () => unregister();
    }, [messageId]);
}
